import React, {useEffect, useState} from "react";
import styles from "./testsResults.module.css";
import RoutesToPages from "../../RoutesToPages";
import {useNavigate} from "react-router-dom";
import ServerRequest from "../../ServerRequests/ServerRequest";

const TestResults = () => {
  const [stressPercent, setStressPercent] = useState(0);
  const [depressionPercent, setDepressionPercent] = useState(0);
  const navigate = useNavigate();
  const identifiableData = JSON.parse(localStorage.getItem('testResultsParams')) ?? null;

  useEffect(() => {
    if (!identifiableData) return;
    ServerRequest.identifyUserData(identifiableData);
  }, []);

  useEffect(() => {
    // Отримуємо збережені значення з localStorage
    const savedStress = localStorage.getItem("stressPercent");
    const savedDepression = localStorage.getItem("depressionPercent");

    if (savedStress && savedDepression) {
      // Якщо значення вже є - використовуємо їх
      animateProgress(setStressPercent, parseInt(savedStress));
      animateProgress(setDepressionPercent, parseInt(savedDepression));
    } else {
      // Генеруємо нові випадкові значення із заданих меж
      const newStress = getRandomInRange(66, 77);
      const newDepression = getRandomInRange(19, 29);

      // Зберігаємо нові значення
      localStorage.setItem("stressPercent", newStress.toString());
      localStorage.setItem("depressionPercent", newDepression.toString());

      // Анімуємо прогрес
      animateProgress(setStressPercent, newStress);
      animateProgress(setDepressionPercent, newDepression);
    }
  }, []);

  // Функція для генерації випадкового числа в діапазоні
  const getRandomInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const animateProgress = (setState, target) => {
    let current = 0;
    const duration = 2000;
    const intervalTime = duration / target;

    const interval = setInterval(() => {
      if (current >= target) {
        clearInterval(interval);
      } else {
        current++;
        setState(current);
      }
    }, intervalTime);
  };

  const ProgressBar = ({label, percent}) => {
    return (
      <div className={styles.progressContainer}>
        <div className={styles.blockTitle}>{label}</div>
        <div className={styles.progressBarOuter}>
          <span
            className={styles.progressNumbersMain}
            style={{color: percent > 50 ? "white" : "#303030"}}
          >
            {percent}%
          </span>
          <div
            className={styles.progressBarInner}
            style={{width: `${percent}%`}}
          ></div>
        </div>
        <div className={styles.progressNumbers}>
          <span className={styles.progressStartNumber}>0%</span>
          <span className={styles.progressEndNumber}>100%</span>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Test results</h1>

      <ProgressBar label="Your stress level:" percent={stressPercent}/>
      <ProgressBar
        label="Your level of depression:"
        percent={depressionPercent}
      />

      <p className={styles.stressDescription}>
        You are showing signs of high stress and seasonal depression. People
        with this condition feel lethargic and exhausted and have difficulty
        sleeping. You should take a few days to rest and get away from
        irritating factors.
      </p>

      <div className={`${styles.blockTitle} ${styles.blockTitleBigMargin}`}>
        Other mental health indicators:
      </div>

      <img
        src={require("../TestResults/img/diagramm_feeling.png")}
        alt="Other mental health indicators:"
        className={styles.resultImage}
      />

      <div className={styles.blockDiagram}>
        <button className={styles.blockDiagramButton}>Total score: 34</button>
      </div>

      <div className={`${styles.blockTitle} ${styles.blockTitleBigMargin}`}>
        Distribution of points for the mental health test:
      </div>

      <ul className={styles.pointsList}>
        <li>
          <strong>0–9 points </strong>
          <span>– No problem. Your mental state is normal.</span>
        </li>
        <li>
          <strong>10–18 points </strong>
          <span>
            – Slight discomfort. Small emotional fluctuations may be present.
          </span>
        </li>
        <li>
          <strong>19–27 points </strong>
          <span>
            – Moderate health. You are advised to pay attention to how you feel
          </span>
        </li>
        <li>
          <strong>28–36 points </strong>
          <span>
            – Signs of possible damage are present. Rest and support are
            recommended
          </span>
        </li>
        <li>
          <strong>37–45 points </strong>
          <span>
            – Moderate problems. It's time to take care of your mental health
          </span>
        </li>
        <li>
          <strong>46–54 points </strong>
          <span>
            – Significant difficulties. Consultation with a professional is
            recommended.
          </span>
        </li>
        <li>
          <strong>55–63 points </strong>
          <span>
            – Significant problems. It is strongly recommended that you consult
            a specialist.
          </span>
        </li>
        <li>
          <strong>64–70 points </strong>
          <span>
            – Serious problems. Immediate professional support is necessary.
          </span>
        </li>
      </ul>

      <div className={`${styles.blockTitle} ${styles.blockTitleBigMargin}`}>
        Your stress level is above average.
      </div>

      <span className={styles.lastText}>
        Reduce it with guided meditations and exercises available on the
        service.
      </span>

      <div
        className={styles.redirectToService}
        onClick={() => navigate(RoutesToPages.loginPage)}
      >
        <span className={styles.redirectToServiceButton}>Home</span>
      </div>
    </div>
  );
};

export default TestResults;
